export const MOBILE_POSITIONS_PAGE_LOCATORS = {
  main: "PositionsPageLocators.main",
  positionsValue: "PositionsPageLocators.positionsValue",
  totalProfitLoss: "PositionsPageLocators.totalProfitLoss",
}
